import { routesBuilder } from '@guiker/api-definition'

import { LegalProfile } from '../../entity'
import { paths } from './paths'
import { updateLegalProfileSchema } from './schemas'

const idNested = routesBuilder<LegalProfile>()({ basePath: paths.legalProfile.one.withId(':userId') })

export const routes = {
  readOneLegalProfile: idNested.buildGet({
    response: null as LegalProfile | null,
  }),
  upsertLegalProfile: idNested.buildPost({
    payloadSchema: updateLegalProfileSchema,
  }),
}
